export default "__VITE_ASSET__tIV9G5qO__";